// This allows us to define a publish schedule in advance and have these promos show/hide.
// The schedule is based on the current date and time. EX: unpublish_at: "2025-03-19T16:42:00" // please use this example set the time if needed

const promoDrawsScheduleConfig = {
  // Promo Draws
  // "C362B105-A0B8-4F1E-B8DB-BF3FC3CAA2D5": {
  //   key: "examplePromo1",
  //   publish_at: "2024-03-10T11:30:00",
  //   unpublish_at: "2025-07-20T20:00:00",
  //   draw_end: "2025-03-20T20:05:00"
  // },
  // "EA2917A2-2D69-4E51-9E9E-A532CADCF887": {
  //   key: "examplePromo2",
  //   publish_at: "2024-03-24T11:30:00",
  //   unpublish_at: "2025-04-16T20:00:00",
  //   draw_end: "2025-04-11T22:05:00"
  // },
  // "D1C1B0B0-8E66-4E59-BD6A-92DB1196B25D": {
  //   key: "1DayTestForWebsite",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   draw_end: "2025-06-02T00:00:00-04:00" // TODO: Double check timezone on all these config dates
  // },
  // "1E0D1EA7-46BE-45D3-B99E-DDA84BED2DFE": {
  // "3BD44206-2BD6-44E1-8845-01C7A839ADF6": {
  //   key: "multiMillionaireMaker2025",
  //   drawType: "poker",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   earning_start: "2025-04-01T08:00:00", // Use the Eastern time that we need, but dont add the -04:00
  //   earning_end: "2025-06-01T23:59:59", // Use the Eastern time that we need, but dont add the -04:00
  //   draw_end: "2025-06-02T00:00:00" // Use the Eastern time that we need, but dont add the -04:00
  // },
  "465": {
    key: "hockeyNightAtPlayground2025",
    drawType: "egd",
    publish_at: "2025-10-30T09:00:00",
    earning_start: "2025-10-30T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2025-11-30T19:30:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2025-11-30T20:45:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2025-11-30T21:00:00"
  },
  "8B5BFDD4-8BAE-4C7D-9D65-9759E341D8A5": {
    key: "multiMillionaireMakerSeptember2025",
    drawType: "poker",
    publish_at: "2025-09-04T13:00:00",
    earning_start: "2025-09-08T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2025-09-28T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2025-09-28T19:00:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2025-09-28T19:00:00"
  },
  // Triple Barrel Cash Blast multi-draw promotion
  "TRIPLE-BARREL-BLAST-2025": {
    key: "tripleBarrelCashBlast2025",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "3608e0b6-e981-4e59-9659-4f13b762d6f7",
        labelKey: "silver"
      },
      {
        promotionId: "c1db36e9-23f7-4a5a-b1ae-60bad9f80ec4",
        labelKey: "gold"
      },
      {
        promotionId: "5f6e41fb-a59f-4131-bd23-a6db02090aad",
        labelKey: "diamond"
      }
    ],
    publish_at: "2025-10-16T09:00:00",
    earning_start: "2025-10-20T08:00:00",
    earning_end: "2025-11-02T08:00:00",
    draw_end: "2025-11-02T22:00:00",
    unpublish_at: "2025-11-02T22:30:00"
  }
};

export default promoDrawsScheduleConfig;
